import { observer } from 'mobx-react-lite';
import { ComponentProps, ReactElement } from 'react';

export const AttachmentIcon = observer(
  (props: ComponentProps<'svg'>): ReactElement => (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <g clipPath='url(#clip0_266_350)'>
        <path d='M16.5 6.75015V17.3301C16.5 19.4201 14.97 21.2801 12.89 21.4801C10.5 21.7101 8.5 19.8401 8.5 17.5001V5.14015C8.5 3.83015 9.44 2.64015 10.74 2.51015C12.24 2.36015 13.5 3.53015 13.5 5.00015V15.5001C13.5 16.0501 13.05 16.5001 12.5 16.5001C11.95 16.5001 11.5 16.0501 11.5 15.5001V6.75015C11.5 6.34015 11.16 6.00015 10.75 6.00015C10.34 6.00015 10 6.34015 10 6.75015V15.3601C10 16.6701 10.94 17.8601 12.24 17.9901C13.74 18.1401 15 16.9701 15 15.5001V5.17015C15 3.08015 13.47 1.22015 11.39 1.02015C9.01 0.790146 7 2.66015 7 5.00015V17.2701C7 20.1401 9.1 22.7101 11.96 22.9801C15.25 23.2801 18 20.7201 18 17.5001V6.75015C18 6.34015 17.66 6.00015 17.25 6.00015C16.84 6.00015 16.5 6.34015 16.5 6.75015Z' />
      </g>
      <defs>
        <clipPath id='clip0_266_350'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  )
);
